export enum DiscountOptionEnum {
  BAHT = 'BAHT',
  PERCENTAGE = 'PERCENTAGE',
}

export const DiscountOptionTypeValue = {
  [DiscountOptionEnum.BAHT]: 'บาท',
  [DiscountOptionEnum.PERCENTAGE]: '%',
}
